import React, { useEffect, useState } from 'react'
import RateSlider from '../../common/RateSlider'
import close from "../../../assets/img/icons/Vector copy.svg"
import Button from '../../shared/Button'
import useFetch from '../../../hooks/useAxios'
import { useParams } from 'react-router-dom'
import toast from 'react-hot-toast'

const PlaceRateModal = ({inforesidencedetail,closeModal}) => {
    const [hosting_quality, sethosting_quality] = useState(0)
    const [location, setlocation] = useState(0)
    const [value_for_money, setvalue_for_money] = useState(0)
    const [authenticity, setauthenticity] = useState(0)
    const [cleanliness, setcleanliness] = useState(0)
    const [postdata, setpostdata] = useState()
  const {slug} = useParams()

    const apirateresidence = useFetch({
      method: "post",
      url: `api/residences/${slug}/rate`,
      noHeader: false,
      trigger: false,
      data:postdata,
      formdata:true,
      argFunc:res=>{
        closeModal()
      },
errMessage:(err)=>{
if(err.response.data.message){
  toast.error(err.response.data.message);
  closeModal()
}
}
      
  
     
    });
    const finishrating = ()=>{
        setpostdata({
            hosting_quality:hosting_quality,
            location:location,
            value_for_money:value_for_money,
            authenticity:authenticity,
            cleanliness:cleanliness
        })
    }
    useEffect(() => {
        if(postdata){
            apirateresidence.reFetch()
        }
    }, [postdata])
    
  return (
    <div className='ModalBackground '>
        <div className='CommentModal p-[25px] CommentBoxModal PlaceRateModal'>
        <div className='flex justify-between  items-center'>
           
           <div>
           <h2 className='text-[#292D32] text-[20px] font-[700]'>نظر شما</h2>
           <p className='text-[#797D82] text-[18px] font-[500]'>در مورد {inforesidencedetail.title}</p>
           </div>
            <button onClick={()=>closeModal()}><img src={close}   /></button>
        </div>
        <hr className='my-[20px]'/>
            <p>امتیاز به نظافت :  </p>
            <RateSlider  defaultvalue={cleanliness} setDefaultValue={setcleanliness}/>
            <p>کیفیت میزبانی : </p>
            <RateSlider defaultvalue={hosting_quality} setDefaultValue={sethosting_quality}/>
           <p>موقعیت مکانی : </p>

            <RateSlider defaultvalue={location} setDefaultValue={setlocation}/>
           <p>ارزش نسبت به قیمت : </p>

            <RateSlider defaultvalue={value_for_money} setDefaultValue={setvalue_for_money}/>
           <p>صحت مطالب : </p>

           <RateSlider defaultvalue={authenticity} setDefaultValue={setauthenticity}/>
           <hr className='my-[10px]'/>

<Button varient="primary" onClick={()=>finishrating()} fullwidth={true} disabled={apirateresidence.loading}> ثبت پاسخ</Button>
        </div>
        
    </div>
  )
}

export default PlaceRateModal